import { useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useLazyGetUserWeeklyWorkingHoursQuery } from "../../../../data/endpoints/app.endpoints";

interface IUserId {
  userId: string;
}

const ExampleBar = ({ userId }: IUserId) => {
  const [userWorkingHoursWeekly, userWorkingHoursWeeklyResult] =
    useLazyGetUserWeeklyWorkingHoursQuery();

  useEffect(() => {
    userWorkingHoursWeekly(userId);
  }, []);

  const data = userWorkingHoursWeeklyResult?.data;

  return (
    <ResponsiveContainer width="100%" height="90%">
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 20,
          left: -32,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="LW" fill="#8884d8" />
        <Bar dataKey="CW" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ExampleBar;
